export enum SponsorPlacements {
  Dashboard = 'Dashboard',
  Tournament = 'Tournaments',
  TournamentBracket = 'Tournaments.Bracket',
  TournamentOverview = 'Tournaments.Overview',
  TournamentMatches = 'Tournaments.Matches',
  TournamentTeams = 'Tournaments.Teams',
  Seasons = 'Seasons',
  SeasonsView = 'Seasons.View',
  Schedule = 'Schedule',
  Games = 'Games',
  Classrooms = 'Classrooms',
  Gamearena = 'Gamearena',
  GamearenaBrowse = 'Gamearena.Browse',
  Teams = 'Teams',
  TeamsOverview = 'Teams.Overview',
  TeamsMembers = 'Teams.Members',
  TeamsStats = 'Teams.Stats',
  TeamsSchedule = 'Teams.Schedule',
}
export enum InvoiceTypes {
  Stadium = 0,
  CoachingHours = 1,
  Student = 2,
  StudentsPart = 3,
}
export const InvoiceTypesNames = {
  0: 'Stadium',
  1: 'Coaching Hours',
  2: 'Student',
  3: `Student's Part`,
};

export enum UserRoles {
  Admin = 0,
  Ogma = 1,
  Student = 2,
  Coach = 3,
  Guardian = 4,
  Fan = 5,
}
export enum GradeLevels {
  Kindergarten = 0,
  first = 1,
  second = 2,
  third = 3,
  fourth = 4,
  fifth = 5,
  sixth = 6,
  seventh = 7,
  eighth = 8,
  freshman = 9,
  sophomore = 10,
  junior = 11,
  senior = 12,
  NotAStudent = 'no',
}

export const GradeLevelsNames: { [key: string]: string } = {
  0: 'Kindergarten',
  1: '1st Grade',
  2: '2nd Grade',
  3: '3rd Grade',
  4: '4th Grade',
  5: '5th Grade',
  6: '6th Grade',
  7: '7th Grade',
  8: '8th Grade',
  9: '9th Grade (Freshman year)',
  10: '10th Grade (Sophomore year)',
  11: '11th Grade (Junior year)',
  12: '12th Grade (Senior year)',
  no: 'Not a student',
};

export enum UserStatus {
  Active = 1,
  Disabled = 0,
}
export const UserStatusNames: { [key: string]: string } = {
  0: 'Disabled',
  1: 'Active',
};
export enum UserEligibilityStatus {
  NotEligible = 0,
  Eligible = 1,
}
export const UserEligibilityStatusNames: { [key: string]: string } = {
  0: 'Not Eligible',
  1: 'Eligible',
};
export const userRoleNames: { [key: string]: string } = {
  0: 'Admin',
  1: 'GM',
  2: 'Student',
  3: 'Coach',
  4: 'Guardian',
  // 5: 'Fan',
};

export enum MatchStatus {
  Upcoming = 0,
  Completed = 1,
  InProgress = 2,
  Overdue = 3,
  Cancelled = 4,
  Forfeit = 5,
  DoubleForfeit = 6,
  ByeMatch = 7,
  RescheduleRequested = 8,
  Benched = 9,
  UpcomingRescheduledFor = 10,
}

export enum StreamingStatus {
  NotStreaming = 0,
  IsStreaming = 1,
}

export enum HighschoolGrades {
  Freshman9thGrade = 1,
  Sophomore10thGrade = 2,
  Junior11thGrade = 3,
  Senior12thGrade = 4,
}
export const schoolStatusNames: { [key: string]: string } = {
  0: 'Active',
  1: 'Disabled',
};
export enum SchoolStatus {
  Active = 0,
  NotActive = 1,
}

export enum OrganizationStatus {
  Disabled = 0,
  Active = 1,
}
export const InvoiceStatusNames: Record<string, string> = {
  0: 'Upcoming',
  1: 'Active',
  2: 'Overdue',
  3: 'Unactive',
  4: 'Processing',
};
export enum InvoiceStatus {
  Upcoming = 0,
  Paid = 1,
  Overdue = 2,
  Unpaid = 3,
  Processing = 4,
}
export enum ScheduledHoursStatus {
  Requested = 0,
  Approved = 1,
  NotApproved = 2,
}
export enum NotificationStatus {
  NotSeen = 0,
  Seen = 1,
}
export enum GameScreenshotType {
  Game = 0,
  Dispute = 1,
  ChatDispute = 2,
}

export enum RescheduleStatus {
  Requested = 0,
  Approved = 1,
  Rejected = 2,
}
export enum DisputeStatus {
  NotChecked = 0,
  Checked = 1,
}

export enum SupportStatus {
  Open = 0,
  Closed = 1,
}

export enum InvoicePaymentType {
  Check = 0,
  Square = 1,
}

export enum ResponseLevel {
  Emergency = 1,
  Urgent = 2,
  Normal = 3,
}

export enum SeverityLevel {
  Outage = 1,
  Critical = 2,
  Urgent = 3,
  Important = 4,
  Monitor = 5,
  Informational = 6,
}

export enum SupportTicketStatus {
  Open = 0,
  Closed = 1,
  Archived = 2,
  InProgress = 3,
}

export const supportTicketStatusName: { [key: string]: string } = {
  0: 'Not Started',
  1: 'Closed',
  2: 'Archived',
  3: 'In Progress',
};

export const supportTicketStatusNameUser: { [key: string]: string } = {
  0: 'Not Assigned',
  1: 'Closed',
  2: 'Archived',
  3: 'In Progress',
};

export enum DateStatus {
  Upcoming = 0,
  Live = 2,
  Completed = 1,
  All = 3,
  UcomingAndLive = 4,
}

export enum SocketActions {
  Connect = 'WS_CONNECT',
  Disconnect = 'WS_DISCONNECT',
  SendChat = 'WS_SEND_CHAT',
  CheckIn = 'WS_CHECK_IN',
  CheckOut = 'WS_CHECK_OUT',
  DeleteClassroomMessage = 'WS_DELETE_CLASSROOM_CHAT_MSG',
  DeleteMatchMessage = 'WS_DELETE_MATCH_CHAT_MSG',
  DeleteTeamMessage = 'WS_DELETE_TEAM_MSG',
  ClassroomConnect = 'WS_CLASSROOM_CONNECT',
  ClassroomDisconnect = 'WS_CLASSROOM_DISCONNECT',
  ClassroomSendChat = 'WS_CLASSROOM_SEND_CHAT',

  ConnectSeasonWeek = 'WS_CONNECT_SEASON_WEEK',
  DisconnectSeasonWeek = 'WS_DISCONNECT_SEASON_WEEK',

  ConnectInbox = 'WS_CONNECT_INBOX',
  ConnectChatroom = 'WS_CONNECT_CHATROOM',
  JoinInbox = 'WS_JOIN_INBOX',
  DisconnectInbox = 'WS_DISCONNECT_INBOX',
  SendChatroomMessage = 'WS_SEND_CHATROOM_MESSAGE',
  DeleteChatroomMessage = 'WS_DELETE_CHATROOM_MESSAGE',
}

export enum SocketMessages {
  // match
  Connect = 'connect',
  Match = 'match',
  Dispute = 'Dispute',
  Reschedules = 'reschedules',
  TeamChat = 'team-chat',
  RoomChat = 'room-chat',
  Chat = 'chat',
  CheckIn = 'check-in',
  CheckOut = 'check-out',
  MatchGame = 'MatchGame',
  UpdateMatchGame = 'UpdateMatchGame',
  Disconnect = 'disconnect',
  JoinRoom = 'join-room',
  EmitDeleteChatMsg = 'classroom-chat-delete',
  DeleteChatMsgMatchAll = 'delete-chat-msg-match-all',
  DeleteTeamMsg = 'delete-chat-msg-match-team',

  // season week
  ConnectSeasonWeek = 'connect-season-week',
  Matches = 'matches',
  Teams = 'teams',

  // Inbox
  ConnectInbox = 'inbox-connect',
  Chatroom = 'chat-room',
  ChatroomMessage = 'new-chatroom-message',
  AddImagesToChatroomChat = 'add-images-to-chatroom-chat',
  ChatroomDispute = 'chatroom-dispute',
  ResolveChatroomDispute = 'resolve-chatroom-dispute',
  unArchiveChatroom = 'unarchive-chatroom',
  NewMatchChat = 'new-match-chat',
  FirstMatchChat = 'first-match-chat',
  FirstChatroomMessage = 'first-chatroom-message',
  NewForfeitAnnouncement = 'new-forfeit-announcement',
  AnnouncementRead = 'announcement-read',
}

export enum TournamentProgressStatus {
  Upcoming = 0,
  Completed = 1,
  Ongoing = 2,
}
export const TournamentStatusNames: Record<string, string> = {
  0: 'Upcoming',
  1: 'Completed',
  2: 'Ongoing',
};
export enum SeasonProgressStatus {
  Upcoming = 0,
  Completed = 1,
  Ongoing = 2,
}

export const allStates = [
  { id: 'Alabama', name: 'Alabama' },
  { id: 'Alaska', name: 'Alaska' },
  { id: 'Arizona', name: 'Arizona' },
  { id: 'Arkansas', name: 'Arkansas' },
  { id: 'California', name: 'California' },
  { id: 'Colorado', name: 'Colorado' },
  { id: 'Connecticut', name: 'Connecticut' },
  { id: 'Delaware', name: 'Delaware' },
  { id: 'Florida', name: 'Florida' },
  { id: 'Georgia', name: 'Georgia' },
  { id: 'Hawaii', name: 'Hawaii' },
  { id: 'Idaho', name: 'Idaho' },
  { id: 'Illinois', name: 'Illinois' },
  { id: 'Indiana', name: 'Indiana' },
  { id: 'Iowa', name: 'Iowa' },
  { id: 'Kansas', name: 'Kansas' },
  { id: 'Kentucky', name: 'Kentucky' },
  { id: 'Louisiana', name: 'Louisiana' },
  { id: 'Maine', name: 'Maine' },
  { id: 'Maryland', name: 'Maryland' },
  { id: 'Massachusetts', name: 'Massachusetts' },
  { id: 'Michigan', name: 'Michigan' },
  { id: 'Minnesota', name: 'Minnesota' },
  { id: 'Mississippi', name: 'Mississippi' },
  { id: 'Missouri', name: 'Missouri' },
  { id: 'Montana', name: 'Montana' },
  { id: 'Nebraska', name: 'Nebraska' },
  { id: 'Nevada', name: 'Nevada' },
  { id: 'New Hampshire', name: 'New Hampshire' },
  { id: 'New Jersey', name: 'New Jersey' },
  { id: 'New Mexico', name: 'New Mexico' },
  { id: 'New York', name: 'New York' },
  { id: 'North Carolina', name: 'North Carolina' },
  { id: 'North Dakota', name: 'North Dakota' },
  { id: 'Ohio', name: 'Ohio' },
  { id: 'Oklahoma', name: 'Oklahoma' },
  { id: 'Oregon', name: 'Oregon' },
  { id: 'Pennsylvania', name: 'Pennsylvania' },
  { id: 'Rhode Island', name: 'Rhode Island' },
  { id: 'South Carolina', name: 'South Carolina' },
  { id: 'South Dakota', name: 'South Dakota' },
  { id: 'Tennessee', name: 'Tennessee' },
  { id: 'Texas', name: 'Texas' },
  { id: 'Utah', name: 'Utah' },
  { id: 'Vermont', name: 'Vermont' },
  { id: 'Virginia', name: 'Virginia' },
  { id: 'Washington', name: 'Washington' },
  { id: 'Washington, D.C', name: 'Washington, D.C' },
  { id: 'West Virginia', name: 'West Virginia' },
  { id: 'Wisconsin', name: 'Wisconsin' },
  { id: 'Wyoming', name: 'Wyoming' },
];

export const allStateCommunities = [
  { id: 'Minnesota Community', name: 'Minnesota Community' },
  { id: 'North Dakota Community', name: 'North Dakota Community' },
  { id: 'South Dakota Community', name: 'South Dakota Community' },
  { id: 'Wisconsin Community', name: 'Wisconsin Community' },
  { id: 'Wyoming Community', name: 'Wyoming Community' },
];

export enum GameIsArchived {
  No = 0,
  Yes = 1,
}

export enum Genders {
  Man = 1,
  Woman = 2,
  Other = 3,
  NotToDisclose = 4,
}
export const genderNames: Record<string, string> = {
  1: 'Man',
  2: 'Woman',
  3: 'Additional gender category/identity not listed',
  4: 'Choose not to disclose',
};
export const gendersOptions = [
  {
    id: 1,
    name: genderNames[Genders.Man],
  },
  {
    id: 2,
    name: genderNames[Genders.Woman],
  },
  {
    id: 3,
    name: genderNames[Genders.Other],
  },
  {
    id: 4,
    name: genderNames[Genders.NotToDisclose],
  },
];

export enum SchemaMessages {
  EndDate = 'End date cannot be before start date',
  DateShouldNotBeInThePast = 'Date and time should not be in the past',
  SelectedDateMusBeFromToday = 'Selected date must be from today',
  SeasonWeekDate = 'Selected date must be after season week start date',
  TournametStartDate = 'Selected date must be after tournament start date',
  AddMatchToWeekDifferentTeam = 'Away team should be different from home team!',
}

export const TicketApprovalStatus = {
  UserNotApproved: 0,
  AdminNotApproved: 0,
  UserApproved: 1,
  AdminApprove: 1,
};

export const priorityLevels: Record<string, string> = {
  1: 'P1',
  2: 'P2',
  3: 'P3',
};

export enum MatchFormats {
  BestOf = 1,
  FirstTo = 2,
  Minimum = 3,
  Chess = 4,
}

export const matchFormatNames: Record<string, string> = {
  [MatchFormats.BestOf]: 'Best Of',
  [MatchFormats.FirstTo]: 'First To',
  [MatchFormats.Minimum]: 'Minimum',
  [MatchFormats.Chess]: 'Chess To',
};
export enum MatchGameStatus {
  Open,
  Closed,
  Review,
}

export enum MatchGameRaceStatus {
  Open,
  Closed,
  Review,
}

export const rescheduleStatuses: Record<string, string> = {
  0: 'Requested',
  1: 'Approved',
  2: 'Rejected',
};

export enum rescheduleStatus {
  Requested = 0,
  Approved = 1,
  Rejected = 2,
}

export const rescheduleRoles: Record<string, string> = {
  0: 'Admin',
  1: 'Ogma',
  2: 'Student',
};

export enum SeasonWeekStatus {
  NotStarted,
  Open,
  Closed,
  Published,
}

export enum TicketStatusTime {
  Open = 0,
  Closed = 1,
  Archived = 2,
  InProgressT1 = 3,
  ToDo = 4,
  InProgressT2 = 5,
  MonitorReview = 6,
}

export enum UserSupportTabStatus {
  Open = 1,
  Closed = 2,
  Archived = 3,
}

export const ForfeitHistoryActions: { [key: string]: string } = {
  1: 'Forfeit',
  2: 'Unforfeit',
  3: 'Double forfeit',
  4: 'Double unforfeit',
};

export enum ProgramTitles {
  DroneRacing = 'Drone Racing',
  Esports = 'Esports',
}

export const ManualTagPrefix = '#';

export enum WarningMessages {
  CanNotAddSubsToOnePlayerTeams = 'No substitutes can be added to a one-player team.',
}

export enum MatchGenerationTypes {
  RoundRobin = 1,
  Swiss = 2,
}

export enum SeasonTypes {
  classic = 1,
  leaderboard = 2,
}

export const SeasonStageTypes = {
  RoundRobin: { id: 1, displayText: 'Round Robin (All play all)' },
  Tournament: { id: 2, displayText: 'Tournament' },
  SkillSync: { id: 3, displayText: 'Skill Sync' },
} as { [key: string]: { id: number; displayText: string } };

export const SeasonStageTeamSelectionMethod = {
  AllTeams: { id: 1, displayText: 'All Teams' },
  SelectTopTeams: { id: 2, displayText: 'Select Top Teams' },
  ManuallySelectTeams: { id: 3, displayText: 'Manually Select Teams' },
};

export enum Games {
  Fortnite = 'Fortnite',
}

export enum TeamSides {
  Home = 'home',
  Away = 'away',
  None = 'none',
}

export enum SeasonProgramTypes {
  Esports = 1,
  DroneRacing = 2,
}

export const DragAndDropFileTypes = 'image/png, image/jpeg, image/webp';

export const SeasonProgramTypesDisplayValues: { [key: number]: string } = {
  [SeasonProgramTypes.Esports]: 'Esports',
  [SeasonProgramTypes.DroneRacing]: 'Drone Racing',
};

export const ClassroomContentBySeasonProgramType = {
  [SeasonProgramTypes.DroneRacing]: {
    seasonProgramType: SeasonProgramTypes.DroneRacing,
    stages: [
      {
        seasonStage: '',
        sections: [
          {
            sectionTitle: 'How to Submit Times',
            videos: [
              {
                title: '1. Student Individual Times',
                url: 'https://youtu.be/EUkDnSZHe3I',
              },
              {
                title: '2. Student Team Times',
                url: 'https://youtu.be/Dh-krxhNYww',
              },
              {
                title: '3. GM Individual Times',
                url: 'https://youtu.be/HUgUiXikmZo',
              },
              { title: '4. GM Team Times', url: 'https://youtu.be/zdUqfvbucI4' },
            ],
          },
          {
            sectionTitle: 'Introduction Videos',
            videos: [
              { title: '1. Basic Safety', url: 'https://youtu.be/0gBiSYUXJSw' },
              { title: '2. Basics of VelociDrone', url: 'https://youtu.be/B0-f1mO3dt0' },
              { title: '3. Betaflight Introduction', url: 'https://youtu.be/i6GzIkESDQE' },
            ],
          },
          {
            sectionTitle: 'Line of Sight Videos',
            videos: [
              { title: '1. LOS Unboxing (Drone Parts)', url: 'https://youtu.be/TF2wRreQptc' },
              { title: '2. LOS This is Your Drone', url: 'https://youtu.be/LZqrI6vpwlc' },
              { title: '3. LOS This is Your Transmitter', url: 'https://youtu.be/ikoM9VA8jaU' },
              { title: '4. LOS Drone Safety', url: 'https://youtu.be/YdFbH7lH0OQ' },
              { title: '5. LOS Basic Controls', url: 'https://youtu.be/yekxR8gzN80' },
              {
                title: '6. LOS Landing, Takeoff, and Hovering',
                url: 'https://youtu.be/wq2rPsWm-gM',
              },
              { title: '7. LOS Basic Stability', url: 'https://youtu.be/BsurFyN7yNs' },
              { title: '8. LOS Vertical Flight Path Changes', url: 'https://youtu.be/9J9gzS2dICA' },
              { title: '9. LOS Directional Control - Yaw', url: 'https://youtu.be/sVd1WNEkkTg' },
              { title: '10. LOS Directional Control + Yaw', url: 'https://youtu.be/K26dyu5chFI' },
              { title: '11. LOS Low Altitude Flight', url: 'https://youtu.be/KbNxpCTwmt4' },
            ],
          },
        ],
      },
      {
        seasonStage: '',
        sections: [
          {
            sectionTitle: 'First-Person View Videos',
            videos: [
              { title: '1. FPV Gear', url: 'https://youtu.be/3sjJ2-L7NPw' },
              {
                title: '2. FPV Transition to FPV Flying',
                url: 'https://youtu.be/0jyttW3FnKc',
              },
              {
                title: '3. FPV Takeoff, Landing and Hovering',
                url: 'https://youtu.be/S1t2kaEG5y8',
              },
              { title: '4. FPV Directional Control', url: 'https://youtu.be/WvoAoDRbCCI' },
              {
                title: '5. FPV Using Yaw to Manipulate Flight Path',
                url: 'https://youtu.be/bPHe0jZlktE',
              },
              {
                title: '6. FPV Low altitude Flight',
                url: 'https://youtu.be/zmFYQdLgzms',
              },
              { title: '7. FPV Flying Close to Objects', url: 'https://youtu.be/8cFX7tAMCjY' },
              {
                title: '8. FPV Putting it all together lesson',
                url: 'https://youtu.be/F-CpFlt0Z-I',
              },
            ],
          },
          {
            sectionTitle: 'Look to the Future',
            videos: [
              { title: '1. Industry Lesson 1', url: 'https://youtu.be/k5VwbkKnxew' },
              {
                title: '2. Industry Lesson 2',
                url: 'https://youtu.be/ZiAANhMn9Xs',
              },
              { title: '3. Look to the future', url: 'https://youtu.be/S741hupWT10' },
            ],
          },
        ],
      },
    ],
  },
  [SeasonProgramTypes.Esports]: {
    seasonProgramType: SeasonProgramTypes.Esports,
    stages: [
      {
        seasonStage: '',
        sections: [
          {
            sectionTitle: 'Game Explaination Videos',
            videos: [
              {
                title: 'Minecraft Bedwars',
                url: 'https://youtu.be/houMR7TR63w',
              },
              {
                title: 'League of Legends',
                url: 'https://youtu.be/-GY6NTrs45E',
              },
              {
                title: 'Rocket League',
                url: 'https://youtu.be/faMMy69P6QU',
              },
              { title: 'Valorant', url: 'https://youtu.be/u3qrMj9Rlkk' },
            ],
          },
          {
            sectionTitle: 'State Tournament Recap',
            videos: [{ title: '', url: 'https://youtu.be/n1rfz9N5DfQ' }],
          },
        ],
      },
    ],
  },
};

export const SkillSyncRegistrationWindow = { timeInMilliseconds: 1000 * 60 * 60, text: 'one hour' };

export enum ChatMessageTypes {
  MatchChat,
  DirectMessage,
  RescheduleNotice,
}

export const ChatMessageTypesNames: Record<ChatMessageTypes, string> = {
  [ChatMessageTypes.MatchChat]: 'Match Chat',
  [ChatMessageTypes.DirectMessage]: 'Direct Message',
  [ChatMessageTypes.RescheduleNotice]: 'Reschedule Notice',
};

export enum InboxAnnouncementTypes {
  ForfeitNotice = 0,
}

export const InboxAnnouncementTypesNames: Record<InboxAnnouncementTypes, string> = {
  [InboxAnnouncementTypes.ForfeitNotice]: 'Forfeit Notice',
};
